export default "__VITE_ASSET__vupRPZSP__"